export function parseStoredCategoryIds(value) {
  if (!value || value === 'all' || value === 'null') return [];

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed;
    if (parsed !== null && parsed !== undefined) return [parsed];
  } catch {
    const numeric = Number(value);
    return [Number.isNaN(numeric) ? value : numeric];
  }

  return [];
}

export function filterByCategoryIds(businesses, selectedIds) {
  if (!selectedIds.length) return businesses;

  const selected = new Set(selectedIds.map(String));
  return businesses.filter((business) => selected.has(String(business.category_id)));
}
